export const lineMenus = [
    [
        '湿地旅鸟与山林夏候鸟初探',
        '山林繁殖鸟与水域夏候鸟奇观',
        '湿地迁徙潮与山林留鸟多样性',
        '濒危物种与冬候鸟集群盛宴',
        '黄山生态全景·全域综合观鸟'
    ],
    [
        '鹇栖秘境·水口园林摄影线',
        '鹭舞浦溪·湿地古树摄影线',
        '鸟羽纷飞·绿叶珍禽摄影线',
        '画里鸣禽·香樟古树摄影线',
        '松涛鸟韵·黄山风光摄影线'
    ],
    [
        '探密谜窟 自然历史穿越之旅',
        '雕梁画栋  非遗生态研习之旅',
        '千年古韵 红茶文化研学之旅',
        '鹤舞瑯梅 微景观造园之旅',
        '湿地交响  生态观测体验之旅'
    ],
    [
        '世界遗产·魅力自然 黄山度假探秘之旅',
        '树灵秘境·鸟韵天堂 黄山生态休闲之旅',
        '古树灵禽·黄山趣游漫行之旅',
        '古村寻幽・茶香鸟影 黄山秘境探趣之旅',
        '山水画卷・徽韵传承 黄山揽胜寻踪之旅'
    ]
]

export const gdLineMenus = [
    '箬岭古道',
    '桃岭古道',
    '徽开古道',
    '霞客古道',
    '徽饶古道',
    '徽池古道',
    '祁黟古道',
    '大洪岭古道',
    '汤岭古道',
    '文昌古道',
    '西宏古道',
    '通灵古道'
]

export const lineMarkers = [
    {
        "id": 49,
        "type": 3,
        "name": "黄山高铁北站",
        "address": "屯溪区迎客松大道北2号",
        "tel": "0559-12306",
        "desc": "",
        "latitude": "29.814866",
        "longitude": "118.273628",
        "icon_longitude": 118.291855,
        "icon_latitude": 29.782858,
        "icon_scale": 120,
        "icon": "marker/line/49.png",
        "wh": 1.415,
        "thumbs": [
            "marker/line/pictures/49/黄山北站.png"
        ]
    },
    {
        "id": 48,
        "type": 3,
        "name": "黄山屯溪国际机场",
        "address": "屯溪区龙井路8号",
        "tel": "0559-2934999",
        "desc": "",
        "latitude": "29.73039",
        "longitude": "118.260716",
        "icon_latitude": "29.73039",
        "icon_longitude": "118.260716",
        "icon_scale": 120,
        "icon": "marker/line/48.png",
        "wh": 1.781,
        "thumbs": [
            "marker/line/pictures/48/黄山屯溪国际机场.png"
        ]
    },
    {
        "id": 50,
        "type": 3,
        "name": "黄山高铁西站",
        "address": "黄山区甘棠镇兴村",
        "tel": "0559-12306",
        "desc": "",
        "latitude": "30.277523",
        "longitude": "118.089448",
        "icon_latitude": "30.277523",
        "icon_longitude": "118.089448",
        "icon_scale": 120,
        "icon": "marker/line/50.png",
        "wh": 1.415,
        "thumbs": [
            "marker/line/pictures/50/黄山西站.png"
        ]
    },
    {
        "id": 52,
        "type": 3,
        "name": "祁门高铁南站",
        "address": "祁门县中心城区南面",
        "tel": "0559-12306",
        "desc": "",
        "latitude": "29.832649",
        "longitude": "117.69929",
        "icon_latitude": "29.832649",
        "icon_longitude": "117.69929",
        "icon_scale": 120,
        "icon": "marker/line/52.png",
        "wh": 1.415,
        "thumbs": [
            "marker/line/pictures/52/祁门南站.png"
        ]
    },
    {
        "id": 54,
        "type": 3,
        "name": "歙县高铁三阳站",
        "address": "歙县三阳镇",
        "tel": "0559-12306",
        "desc": "",
        "latitude": "30.027048",
        "longitude": "118.807798",
        "icon_latitude": "30.027048",
        "icon_longitude": "118.807798",
        "icon_scale": 120,
        "icon": "marker/line/54.png",
        "wh": 1.415,
        "thumbs": [
            "marker/line/pictures/54/三阳站.png"
        ]
    },
    {
        "id": 53,
        "type": 3,
        "name": "歙县高铁北站",
        "address": "歙县富堨镇承狮村北",
        "tel": "0559-12306",
        "desc": "",
        "latitude": "29.921445",
        "longitude": "118.410987",
        "icon_latitude": "29.921445",
        "icon_longitude": "118.410987",
        "icon_scale": 120,
        "icon": "marker/line/53.png",
        "wh": 1.415,
        "thumbs": [
            "marker/line/pictures/53/歙县北站.png"
        ]
    },
    {
        "id": 51,
        "type": 3,
        "name": "黟县高铁东站",
        "address": "黟县西递镇源川村",
        "tel": "0559-12306",
        "desc": "",
        "latitude": "29.884967",
        "longitude": "118.047733",
        "icon_latitude": "29.884967",
        "icon_longitude": "118.017733",
        "icon_scale": 120,
        "icon": "marker/line/51.png",
        "wh": 1.415,
        "thumbs": [
            "marker/line/pictures/51/黟县东站_.png"
        ]
    }
]

export const emptyLineMarkers = [
    {
        "id": 1,
        "type": 3,
        "name": "屯溪老街",
        "address": "屯溪区屯溪老街",
        "tel": "",
        "desc": "有“活动着的清明上河图”之称，是中国保存最完整、最具有南宋和明清建筑风格的古代街市。",
        "latitude": "29.708422",
        "longitude": "118.307321",
        "icon_latitude": "29.719422",
        "icon_longitude": "118.307321",
        "icon_scale": 100,
        "icon": "marker/line/1.png",
        "wh": 1.131,
        "thumbs": [
            "marker/line/pictures/1/屯溪区-屯溪老街.JPG",
            "marker/line/pictures/1/屯溪区-屯溪老街1.jpg"
        ]
    },
    {
        "id": 2,
        "type": 3,
        "name": "屯溪河街",
        "address": "屯溪区屯溪河街",
        "tel": "",
        "desc": "紧邻屯溪老街，是一处集休闲、旅游、体验、购物于一体的文化空间。",
        "latitude": "29.706942",
        "longitude": "118.306657",
        "icon_latitude": "29.706942",
        "icon_longitude": "118.326657",
        "icon_scale": 100,
        "icon": "marker/line/2.png",
        "wh": 1.345,
        "thumbs": [
            "marker/line/pictures/2/屯溪区-屯溪河街.jpg",
            "marker/line/pictures/2/屯溪区-屯溪河街1.jpg",
            "marker/line/pictures/2/屯溪区-屯溪河街2.jpg"
        ]
    },
    {
        "id": 3,
        "type": 3,
        "name": "黎阳in巷（4A）",
        "address": "屯溪区黎阳 in 巷",
        "tel": "0559-2560088",
        "desc": "位于黄山市三江交汇绝佳景观之处，与屯溪老街一桥之隔，是集餐饮、休闲、文化、零售为一体的时尚文化旅游街区。",
        "latitude": "29.706258",
        "longitude": "118.298714",
        "icon_latitude": "29.706258",
        "icon_longitude": "118.298714",
        "icon_scale": 110,
        "icon": "marker/line/3.png",
        "wh": 1.563,
        "thumbs": [
            "marker/line/pictures/3/屯溪区-黎阳in巷.png",
            "marker/line/pictures/3/屯溪区-黎阳in巷1.jpg",
            "marker/line/pictures/3/屯溪区-黎阳in巷2.png"
        ]
    },
    {
        "id": 4,
        "type": 3,
        "name": "花山世界·花山谜窟（4A）",
        "address": "屯溪区屯光镇花山路",
        "tel": "0559-2359888",
        "desc": "总面积约为1200亩，是一处集主题化、休闲化、科技化于一体，同时兼顾日游和夜游的沉浸式智慧旅游园区。",
        "latitude": "29.744423",
        "longitude": "118.389019",
        "icon_latitude": "29.724423",
        "icon_longitude": "118.389019",
        "icon_scale": 90,
        "icon": "marker/line/4.png",
        "wh": 2.438,
        "thumbs": [
            "marker/line/pictures/4/屯溪区-花山世界·花山谜窟.JPG",
            "marker/line/pictures/4/屯溪区-花山世界·花山谜窟1.png"
        ]
    },
    {
        "id": 5,
        "type": 3,
        "name": "新安江滨水旅游景区（4A）",
        "address": "屯溪区瑶里路 8 号",
        "tel": "0559-2327868",
        "desc": "由“林廊清影”“屯浦归帆”“屯溪码头”“坝址广场”“湖边村落”“照壁怀古”“湿地栈道”“摩崖石刻”“徽风街”“山阁远眺”新安十景组成，展现出一幅气势磅礴的新安江胜景图。",
        "latitude": "29.729068",
        "longitude": "118.356439",
        "icon_latitude": "29.709068",
        "icon_longitude": "118.369439",
        "icon_scale": 115,
        "icon": "marker/line/5.png",
        "wh": 2.649,
        "thumbs": [
            "marker/line/pictures/5/屯溪区-新安江滨水旅游景区.jpg",
            "marker/line/pictures/5/屯溪区-新安江滨水旅游景区1.jpg"
        ]
    },
    {
        "id": 6,
        "type": 3,
        "name": "黄山风景区（5A）",
        "address": "黄山区汤口镇 205 国道",
        "tel": "0559-5561111",
        "desc": "黄山是全球首个集世界文化与自然遗产、世界地质公园、世界生物圈保护区于一身的风景名胜区，与长江、长城、黄河并为中华民族的象征，被誉为“天下第一奇山”，素以奇松、怪石、云海、温泉、冬雪“五绝”著称于世。境内群峰竞秀，怪石林立，有千米以上高峰88座，莲花峰、光明顶、天都峰三大主峰，海拔均逾1800米。黄山四季皆胜景，日出、晚霞、云彩、佛光和雾凇等时令景观也是各得其趣。",
        "latitude": "30.126561",
        "longitude": "118.170467",
        "icon_latitude": "30.126561",
        "icon_longitude": "118.170467",
        "icon_scale": 105,
        "icon": "marker/line/6.png",
        "wh": 1.851,
        "thumbs": [
            "marker/line/pictures/6/黄山区-黄山风景区.jpg",
            "marker/line/pictures/6/黄山区-黄山风景区1.jpg",
            "marker/line/pictures/6/黄山区-黄山风景区2.jpg"
        ]
    },
    {
        "id": 7,
        "type": 3,
        "name": "太平湖（4A）",
        "address": "黄山区太平湖镇",
        "tel": "0559-8561515",
        "desc": "太平湖水终年清澈碧透，湖中岛屿散落如珠，湖畔青山连绵起伏。景区有体现自然风光的黄金岛，有反映徽派建筑风格的天下太平城，有体味人与自然亲和互进的猴魁岛，有融古陶文化与自然景观为一体的龙窑寨，有惊险刺激、亲水休闲的水上运动系列项目等。",
        "latitude": "30.400808",
        "longitude": "118.059916",
        "icon_latitude": "30.400808",
        "icon_longitude": "118.059916",
        "icon_scale": 80,
        "icon": "marker/line/7.png",
        "wh": 1.946,
        "thumbs": [
            "marker/line/pictures/7/黄山区-太平湖.jpg",
            "marker/line/pictures/7/黄山区-太平湖1.jpg"
        ]
    },
    {
        "id": 8,
        "type": 3,
        "name": "翡翠谷（4A）",
        "address": "黄山区汤口镇山岔村翡翠谷景区",
        "tel": "0559-5577655",
        "desc": "又名“情人谷”，著名奥斯卡获奖影片《卧虎藏龙》中，竹梢打斗、池边爱恋等场景都是在翡翠谷取景拍摄的。",
        "latitude": "30.115275",
        "longitude": "118.219613",
        "icon_latitude": "30.115275",
        "icon_longitude": "118.219613",
        "icon_scale": 88,
        "icon": "marker/line/8.png",
        "wh": 1.565,
        "thumbs": [
            "marker/line/pictures/8/黄山区-翡翠谷.jpg",
            "marker/line/pictures/8/黄山区-翡翠谷1.jpg",
            "marker/line/pictures/8/黄山区-翡翠谷2.jpg"
        ]
    },
    {
        "id": 9,
        "type": 3,
        "name": "芙蓉谷（4A）",
        "address": "黄山区耿诚镇辅村",
        "tel": "0559-8551518",
        "desc": "位于黄山北麓，纵深4公里，谷中群峰嵯峨，怪石嶙峋，大小潭池上百个，构成美妙的水景幻境，充满着青春神韵，故又称“春之谷”。",
        "latitude": "30.193576",
        "longitude": "118.158817",
        "icon_latitude": "30.193576",
        "icon_longitude": "118.158817",
        "icon_scale": 105,
        "icon": "marker/line/9.png",
        "wh": 1.33,
        "thumbs": [
            "marker/line/pictures/9/黄山区-芙蓉谷.jpg",
            "marker/line/pictures/9/黄山区-芙蓉谷1.jpg"
        ]
    },
    {
        "id": 10,
        "type": 3,
        "name": "九龙瀑（4A）",
        "address": "黄山区 G205（山深线）九龙瀑景区",
        "tel": "0559-5561184",
        "desc": "黄山三大瀑布之一，也是三大瀑布中最壮观者。",
        "latitude": "30.102178",
        "longitude": "118.203558",
        "icon_latitude": "30.102178",
        "icon_longitude": "118.203558",
        "icon_scale": 99,
        "icon": "marker/line/10.png",
        "wh": 1.489,
        "thumbs": [
            "marker/line/pictures/10/黄山区-九龙瀑.jpg",
            "marker/line/pictures/10/黄山区-九龙瀑1.jpg"
        ]
    },
    {
        "id": 11,
        "type": 3,
        "name": "东黄山度假区（4A）",
        "address": "黄山区谭家桥镇",
        "tel": "0559-8591999",
        "desc": "被誉为“梦的驿站”，度假区内自然、人文历史资源丰富，注重旅游文化品牌的打造。",
        "latitude": "30.150646",
        "longitude": "118.296584",
        "icon_latitude": "30.150646",
        "icon_longitude": "118.296584",
        "icon_scale": 96,
        "icon": "marker/line/11.png",
        "wh": 2.212,
        "thumbs": [
            "marker/line/pictures/11/黄山区-东黄山度假区.jpg",
            "marker/line/pictures/11/黄山区-东黄山度假区1.jpg",
            "marker/line/pictures/11/黄山区-东黄山度假区2.jpg"
        ]
    },
    {
        "id": 12,
        "type": 3,
        "name": "岩寺新四军军部旧址纪念馆（4A）",
        "address": "徽州区岩寺镇滨河南路 39 号",
        "tel": "0559-3585699",
        "desc": "新四军全国五处重要旧址之一、全国重点文物保护单位、国家级抗战纪念设施（遗址）、国家国防教育示范基地、全国红色旅游经典景区。",
        "latitude": "29.820463",
        "longitude": "118.335971",
        "icon_latitude": "29.820463",
        "icon_longitude": "118.335971",
        "icon_scale": 128,
        "icon": "marker/line/12.png",
        "wh": 1.863,
        "thumbs": [
            "marker/line/pictures/12/徽州区-岩寺新四军军部旧址纪念馆.jpg",
            "marker/line/pictures/12/徽州区-岩寺新四军军部旧址纪念馆1.jpg"
        ]
    },
    {
        "id": 13,
        "type": 3,
        "name": "谢裕大茶博园（4A）",
        "address": "徽州区潜口镇谢裕大东路 99 号",
        "tel": "0559-5201919",
        "desc": "分为一馆四园，包括谢裕大茶文化博物馆、黄山茶树种优质资源保护园、高效双茶示范园、黄山特色山珍种植园以及立体循环养殖园。",
        "latitude": "29.867459",
        "longitude": "118.320583",
        "icon_latitude": "29.867459",
        "icon_longitude": "118.320583",
        "icon_scale": 75,
        "icon": "marker/line/13.png",
        "wh": 2.928,
        "thumbs": [
            "marker/line/pictures/13/徽州区-谢裕大茶博园.png",
            "marker/line/pictures/13/徽州区-谢裕大茶博园1.jpg"
        ]
    },
    {
        "id": 14,
        "type": 3,
        "name": "大灵山度假区",
        "address": "徽州区零四三村道",
        "tel": "",
        "desc": "围绕“吃住行游购娱”,规划了山水乐游、康体疗养、文化体验、夜游演艺、节事节庆、诗意美宿、徽派风味、灵山好礼在内的八大度假产品体系，推出灵山之学、灵山之恋、灵山之醉、灵山之醉四大主题产品，丰富灵山“四绝”内涵。",
        "latitude": "29.916144",
        "longitude": "118.320372",
        "icon_latitude": "29.916144",
        "icon_longitude": "118.320372",
        "icon_scale": 83,
        "icon": "marker/line/14.png",
        "wh": 1.944,
        "thumbs": [
            "marker/line/pictures/14/徽州区-大灵山度假区.jpg",
            "marker/line/pictures/14/徽州区-大灵山度假区1.jpg",
            "marker/line/pictures/14/徽州区-大灵山度假区2.jpg",
            "marker/line/pictures/14/徽州区-大灵山度假区3.jpg"
        ]
    },
    {
        "id": 15,
        "type": 3,
        "name": "古徽州文化旅游区·呈坎（5A）",
        "address": "徽州区呈坎镇呈坎村宝纶路 7 号",
        "tel": "0559-3537777",
        "desc": "距今有1800多年历史，完整保存着宋、元、明等年代的古建筑群，汇聚了徽派不同风格的亭、台、楼、阁、桥、祠、井、社和民居。",
        "latitude": "29.923757",
        "longitude": "118.28512",
        "icon_latitude": "29.923757",
        "icon_longitude": "118.28512",
        "icon_scale": 95,
        "icon": "marker/line/15.png",
        "wh": 2.131,
        "thumbs": [
            "marker/line/pictures/15/徽州区-呈坎.jpg",
            "marker/line/pictures/15/徽州区-呈坎1.png",
            "marker/line/pictures/15/徽州区-呈坎2.JPG",
            "marker/line/pictures/15/徽州区-呈坎3.jpg"
        ]
    },
    {
        "id": 16,
        "type": 3,
        "name": "古徽州文化旅游区·潜口民宅（5A）",
        "address": "徽州区潜口村潜黄路 1 号",
        "tel": "0559-3531790",
        "desc": "潜口民宅博物馆将散落在徽州民间的部分明清两代古建筑集中迁移加以保护，是国家重点文物保护单位，由明园和清园两座山庄组成，被誉为“中国明、清民间艺术的活专著”。",
        "latitude": "29.86903",
        "longitude": "118.293224",
        "icon_latitude": "29.86903",
        "icon_longitude": "118.293224",
        "icon_scale": 109,
        "icon": "marker/line/16.png",
        "wh": 1.899,
        "thumbs": [
            "marker/line/pictures/16/徽州区-潜口民宅.jpg",
            "marker/line/pictures/16/徽州区-潜口民宅1.JPG"
        ]
    },
    {
        "id": 17,
        "type": 3,
        "name": "古徽州文化旅游区·唐模（5A）",
        "address": "徽州区潜口镇唐模村",
        "tel": "0559-3539095",
        "desc": "始建于唐，盛于明清，以“唐代古树之茂、中街流水之雅、水口园林之美、书法碑刻之精、十桥九貌之胜、同胞翰林之誉”闻名遐迩。",
        "latitude": "29.869135",
        "longitude": "118.334699",
        "icon_latitude": "29.883135",
        "icon_longitude": "118.334699",
        "icon_scale": 130,
        "icon": "marker/line/17.png",
        "wh": 1.618,
        "thumbs": [
            "marker/line/pictures/17/徽州区-唐模.jpg",
            "marker/line/pictures/17/徽州区-唐模1.jpg",
            "marker/line/pictures/17/徽州区-唐模2.jpg"
        ]
    },
    {
        "id": 18,
        "type": 3,
        "name": "西溪南",
        "address": "徽州区松明山公路",
        "tel": "0559-2772020",
        "desc": "由后唐始建，经五代、两宋，鼎盛于明清。村落结构如棋盘格局，街依溪行，屋缘街建，两岸夹峙，鳞次栉比。漫步其间，丰溪八景，望山生活，如诗如画。",
        "latitude": "29.84041",
        "longitude": "118.28485",
        "icon_latitude": "29.84041",
        "icon_longitude": "118.28485",
        "icon_scale": 89,
        "icon": "marker/line/18.png",
        "wh": 1.085,
        "thumbs": [
            "marker/line/pictures/18/徽州区-西溪南.jpg",
            "marker/line/pictures/18/徽州区-西溪南1.jpg",
            "marker/line/pictures/18/徽州区-西溪南2.jpg"
        ]
    },
    {
        "id": 19,
        "type": 3,
        "name": "新安江山水画廊（4A）",
        "address": "歙县深渡镇新安江山水画廊",
        "tel": "0559—6511599",
        "desc": "景区以中国独特的徽文化与自然风光、古村落结合著称。一年四季，景色各异，似一幅流动的山水画卷，故称之为“新安江百里画廊”。",
        "latitude": "29.862759",
        "longitude": "118.618589",
        "icon_latitude": "29.862759",
        "icon_longitude": "118.618589",
        "icon_scale": 75,
        "icon": "marker/line/19.png",
        "wh": 3.224,
        "thumbs": [
            "marker/line/pictures/19/歙县-新安江山水画廊.JPG",
            "marker/line/pictures/19/歙县-新安江山水画廊1.jpg",
            "marker/line/pictures/19/歙县-新安江山水画廊2.jpg",
            "marker/line/pictures/19/歙县-新安江山水画廊3.jpg"
        ]
    },
    {
        "id": 20,
        "type": 3,
        "name": "雄村（4A）",
        "address": "歙县雄村",
        "tel": "0559-6270000",
        "desc": "桃花古坝濒临渐江水，背靠竹山书院及大中丞功名牌坊。阳春三月，各种色彩的桃花绵延数十米，形成“十里红云”的盛景。",
        "latitude": "29.815761",
        "longitude": "118.443313",
        "icon_latitude": "29.815761",
        "icon_longitude": "118.443313",
        "icon_scale": 80,
        "icon": "marker/line/20.png",
        "wh": 1.478,
        "thumbs": [
            "marker/line/pictures/20/歙县-雄村.JPG",
            "marker/line/pictures/20/歙县-雄村2.jpg"
        ]
    },
    {
        "id": 21,
        "type": 3,
        "name": "安徽徽州历史博物馆",
        "address": "歙县徽州古城内南谯楼南侧",
        "tel": "0559-6530181",
        "desc": "位于徽州古城内，国家二级博物馆，收藏有书画、瓷器、砚台、徽墨、徽州三雕、金玉器、古籍善本、青铜、竹雕等各类文物30000多件，其中馆藏国家一级文物62件（套）。",
        "latitude": "29.864003",
        "longitude": "118.435686",
        "icon_latitude": "29.864003",
        "icon_longitude": "118.465686",
        "icon_scale": 72,
        "icon": "marker/line/21.png",
        "wh": 3.255,
        "thumbs": [
            "marker/line/pictures/21/歙县-安徽徽州历史博物馆.jpg",
            "marker/line/pictures/21/歙县-安徽徽州历史博物馆1.jpg"
        ]
    },
    {
        "id": 22,
        "type": 3,
        "name": "古徽州文化旅游区·徽州古城（5A）",
        "address": "歙县徽州路",
        "tel": "0559—6526109",
        "desc": "中国四大古城之一，始建于秦朝，自隋代至清末，一直是徽州郡、州、路、府所在地，有“东南邹鲁、礼仪之邦、文物之海、程朱故里”之美称。",
        "latitude": "29.866991",
        "longitude": "118.43458",
        "icon_latitude": "29.866991",
        "icon_longitude": "118.43458",
        "icon_scale": 130,
        "icon": "marker/line/22.png",
        "wh": 1.569,
        "thumbs": [
            "marker/line/pictures/22/歙县-徽州古城.jpg",
            "marker/line/pictures/22/歙县-徽州古城1.jpg",
            "marker/line/pictures/22/歙县-徽州古城2.jpg"
        ]
    },
    {
        "id": 23,
        "type": 3,
        "name": "古徽州文化旅游区棠樾牌坊群·鲍家花园（5A）",
        "address": "歙县郑村镇棠樾村",
        "tel": "0559-6751111",
        "desc": "位于“山清水秀”的歙县棠樾村内，由古牌坊、古祠堂、古民居、鲍家花园组成。",
        "latitude": "29.866902",
        "longitude": "118.369767",
        "icon_latitude": 29.887202,
        "icon_longitude": 118.413199,
        "icon_scale": 130,
        "icon": "marker/line/23.png",
        "wh": 1.904,
        "thumbs": [
            "marker/line/pictures/23/歙县-鲍家花园.jpg",
            "marker/line/pictures/23/歙县-鲍家花园1.jpg",
            "marker/line/pictures/23/歙县-鲍家花园2.jpg"
        ]
    },
    {
        "id": 24,
        "type": 3,
        "name": "石潭",
        "address": "歙县007乡道东150米",
        "tel": "0559—6950109",
        "desc": "村庄依山傍水，是摄影爱好者的天堂。每年3-4月，连绵起伏的群山中，油菜花漫山遍野，伴随着山中云雾缭绕，古村落若隐若现相映成景，美若仙境。",
        "latitude": "29.934597",
        "longitude": "118.669603",
        "icon_latitude": "29.934597",
        "icon_longitude": "118.669603",
        "icon_scale": 83,
        "icon": "marker/line/24.png",
        "wh": 1.387,
        "thumbs": [
            "marker/line/pictures/24/歙县-石潭.jpg",
            "marker/line/pictures/24/歙县-石潭1.jpg",
            "marker/line/pictures/24/歙县-石潭2.jpg"
        ]
    },
    {
        "id": 25,
        "type": 3,
        "name": "许村",
        "address": "歙县许村镇007县道",
        "tel": "0559-6600378",
        "desc": "全国重点文物保护单位，距今有1800多年历史。村内保存较好的明、清、民国及现代传统建筑近百幢，主要有彤史垂芳坊、大郡伯第门坊、高阳桥、双寿承恩坊、大观亭、五马坊等徽派建筑。",
        "latitude": "29.99085",
        "longitude": "118.32708",
        "icon_latitude": "29.99085",
        "icon_longitude": "118.32708",
        "icon_scale": 110,
        "icon": "marker/line/25.png",
        "wh": 1.104,
        "thumbs": [
            "marker/line/pictures/25/歙县-许村.jpg",
            "marker/line/pictures/25/歙县-许村1.jpg",
            "marker/line/pictures/25/歙县-许村2.jpg"
        ]
    },
    {
        "id": 26,
        "type": 3,
        "name": "阳产土楼",
        "address": "歙县阳产村",
        "tel": "0559-2751208",
        "desc": "这是一个依山而筑的小山寨，有着400多年历史，因壮观奇特的土楼建筑而闻名。",
        "latitude": "29.868745",
        "longitude": "118.659081",
        "icon_latitude": "29.868745",
        "icon_longitude": "118.659081",
        "icon_scale": 95,
        "icon": "marker/line/26.png",
        "wh": 1.275,
        "thumbs": [
            "marker/line/pictures/26/歙县-阳产土楼.jpg",
            "marker/line/pictures/26/歙县-阳产土楼1.jpg",
            "marker/line/pictures/26/歙县-阳产土楼2.jpg"
        ]
    },
    {
        "id": 27,
        "type": 3,
        "name": "卖花渔村",
        "address": "歙县卖花渔村",
        "tel": "",
        "desc": "卖花渔村，四面环山，花木遍野，这个地方不打渔只卖花，家家户户都以种花、制作盆景为生，叫“渔”是因为村子形似鱼。每到初春之际，山村繁花如烟，沟谷里开满梅花，有的似云霞烂漫，有的如烟花灿烂，落英缤纷，如梦如幻。",
        "latitude": "29.830023",
        "longitude": "118.499731",
        "icon_latitude": "29.830023",
        "icon_longitude": "118.499731",
        "icon_scale": 90,
        "icon": "marker/line/27.png",
        "wh": 1.45,
        "thumbs": [
            "marker/line/pictures/27/歙县-卖花渔村.jpg",
            "marker/line/pictures/27/歙县-卖花渔村1.jpg",
            "marker/line/pictures/27/歙县-卖花渔村2.jpg"
        ]
    },
    {
        "id": 28,
        "type": 3,
        "name": "齐云山（4A）",
        "address": "休宁县齐云山镇县城西侧",
        "tel": "0559-2677777",
        "desc": "古称“白岳”，是国家级风景名胜区，国家地质公园。与黄山南北辉映，风景绮丽，素有“黄山白岳甲江南”之美誉。",
        "latitude": "29.812065",
        "longitude": "118.026066",
        "icon_latitude": "29.812065",
        "icon_longitude": "118.026066",
        "icon_scale": 95,
        "icon": "marker/line/28.png",
        "wh": 1.494,
        "thumbs": [
            "marker/line/pictures/28/休宁县-齐云山.jpg",
            "marker/line/pictures/28/休宁县-齐云山1.jpg",
            "marker/line/pictures/28/休宁县-齐云山2.jpg"
        ]
    },
    {
        "id": 29,
        "type": 3,
        "name": "古城岩（4A）",
        "address": "休宁县万安镇东侧",
        "tel": "0559-7816008",
        "desc": "以众多的古迹遗址、悠久的历史传承和寿山初旭的奇特景观而闻名于世。",
        "latitude": "29.782262",
        "longitude": "118.22533",
        "icon_latitude": "29.782262",
        "icon_longitude": "118.22533",
        "icon_scale": 86,
        "icon": "marker/line/29.png",
        "wh": 1.654,
        "thumbs": [
            "marker/line/pictures/29/休宁县-古城岩.jpg",
            "marker/line/pictures/29/休宁县-古城岩1.jpg",
            "marker/line/pictures/29/休宁县-古城岩2.jpg",
            "marker/line/pictures/29/休宁县-古城岩3.jpg"
        ]
    },
    {
        "id": 30,
        "type": 3,
        "name": "齐云山自由家营地",
        "address": "休宁县齐云山镇县城西侧",
        "tel": "0559-2669988",
        "desc": "以“户外、运动、休闲”为功能定位，以生态树屋为特色主题，将树屋、特色屋、集装箱建筑、房车、户外活动等营地元素整合起来，致力于打造国内家庭度假知名品牌。",
        "latitude": "29.819328",
        "longitude": "118.042715",
        "icon_latitude": "29.819328",
        "icon_longitude": "118.042715",
        "icon_scale": 95,
        "icon": "marker/line/30.png",
        "wh": 2.257,
        "thumbs": [
            "marker/line/pictures/30/休宁县-自由家.jpg",
            "marker/line/pictures/30/休宁县-自由家1.jpg",
            "marker/line/pictures/30/休宁县-自由家2.jpg",
            "marker/line/pictures/30/休宁县-自由家3.JPG"
        ]
    },
    {
        "id": 31,
        "type": 3,
        "name": "状元博物馆",
        "address": "休宁县萝宁街状元广场 1 号",
        "tel": "0559-7512964",
        "desc": "中国唯一以展示状元文化为主、兼容中国传统文化与地方民俗于一体的博物馆。",
        "latitude": "29.784588",
        "longitude": "118.18332",
        "icon_latitude": "29.784588",
        "icon_longitude": "118.18332",
        "icon_scale": 85,
        "icon": "marker/line/31.png",
        "wh": 1.623,
        "thumbs": [
            "marker/line/pictures/31/休宁县-状元博物馆.jpg",
            "marker/line/pictures/31/休宁县-状元博物馆1.JPG",
            "marker/line/pictures/31/休宁县-状元博物馆2.jpg"
        ]
    },
    {
        "id": 32,
        "type": 3,
        "name": "徽州大峡谷",
        "address": "休宁县源芳乡徽州大峡谷",
        "tel": "0559-7773777",
        "desc": "距市区仅16公里，分为源芳急速漂流、源芳翠谷、仰山寺三大游览区，是节假日休闲度假的最佳胜地。",
        "latitude": "29.583693",
        "longitude": "118.336887",
        "icon_latitude": "29.583693",
        "icon_longitude": "118.336887",
        "icon_scale": 90,
        "icon": "marker/line/32.png",
        "wh": 1.488,
        "thumbs": [
            "marker/line/pictures/32/休宁县-徽州大峡谷.jpg",
            "marker/line/pictures/32/休宁县-徽州大峡谷1.jpg"
        ]
    },
    {
        "id": 33,
        "type": 3,
        "name": "岭南",
        "address": "休宁县岭南乡岭南景区",
        "tel": "15061121888",
        "desc": "景区建设有高空玻璃水滑道、极限高空蹦极、七彩滑道等游乐项目，是一个旅游、度假、休闲娱乐为一体的景区。",
        "latitude": "29.434285",
        "longitude": "118.167383",
        "icon_latitude": "29.434285",
        "icon_longitude": "118.167383",
        "icon_scale": 108,
        "icon": "marker/line/33.png",
        "wh": 0.864,
        "thumbs": [
            "marker/line/pictures/33/休宁县-岭南.jpg",
            "marker/line/pictures/33/休宁县-岭南1.jpg"
        ]
    },
    {
        "id": 34,
        "type": 3,
        "name": "枧潭",
        "address": "休宁县蓝田镇",
        "tel": "0559-7840588",
        "desc": "村舍棋布，土墙木屋，堪称“原始部落”。景区生态环境绝佳，还有惊险刺激的漂流、全地形ATV、农事体验等体验。",
        "latitude": "29.989555",
        "longitude": "118.072573",
        "icon_latitude": "29.989555",
        "icon_longitude": "118.072573",
        "icon_scale": 88,
        "icon": "marker/line/34.png",
        "wh": 1.13,
        "thumbs": [
            "marker/line/pictures/34/休宁县-枧潭.jpg",
            "marker/line/pictures/34/休宁县-枧潭1.JPG"
        ]
    },
    {
        "id": 35,
        "type": 3,
        "name": "宏村（5A）",
        "address": "黟县宏村",
        "tel": "0559-5541158",
        "desc": "世界文化遗产宏村是一座牛形水系古村落，各户皆有水道相连，层楼叠院与湖光山色交辉相映，处处是景，步步入画，被誉为“中国画里乡村”。",
        "latitude": "30.002422",
        "longitude": "117.990001",
        "icon_latitude": "30.002422",
        "icon_longitude": "117.990001",
        "icon_scale": 88,
        "icon": "marker/line/35.png",
        "wh": 1.49,
        "thumbs": [
            "marker/line/pictures/35/黟县-宏村.jpg",
            "marker/line/pictures/35/黟县-宏村1.jpg",
            "marker/line/pictures/35/黟县-宏村2.jpg"
        ]
    },
    {
        "id": 36,
        "type": 3,
        "name": "西递（5A）",
        "address": "黟县西递村",
        "tel": "0559-5154030",
        "desc": "世界文化遗产、世界最佳旅游乡村西递距今已经有950余年历史，村内古民居错落有致，砖、木、石雕点缀其间，被誉为“桃花源里人家”。 ",
        "latitude": "29.903355",
        "longitude": "117.996016",
        "icon_latitude": "29.893355",
        "icon_longitude": "117.976016",
        "icon_scale": 110,
        "icon": "marker/line/36.png",
        "wh": 1.096,
        "thumbs": [
            "marker/line/pictures/36/黟县-西递.jpg",
            "marker/line/pictures/36/黟县-西递1.jpg",
            "marker/line/pictures/36/黟县-西递2.jpg"
        ]
    },
    {
        "id": 37,
        "type": 3,
        "name": "归园·赛金花故居（4A）",
        "address": "黟县赛金花景区",
        "tel": "0559-5183199",
        "desc": "通过赛金花故居、书斋、陈列馆以及从国内外收集的大量图片资料，再现了清末“护国娘娘”“平康女侠”赛金花的一生。",
        "latitude": "29.957913",
        "longitude": "117.957388",
        "icon_latitude": "29.957913",
        "icon_longitude": "117.957388",
        "icon_scale": 100,
        "icon": "marker/line/37.png",
        "wh": 2.47,
        "thumbs": [
            "marker/line/pictures/37/黟县-归园·赛金花.jpg",
            "marker/line/pictures/37/黟县-归园·赛金花1.jpg"
        ]
    },
    {
        "id": 38,
        "type": 3,
        "name": "屏山（4A）",
        "address": "黟县宏村镇屏山村",
        "tel": "0559-2266617",
        "desc": "距今已有1100多年历史，因村北的屏风山状如屏风而得名。在明清鼎盛时期，号称“八百烟灶、三千丁男、五里长街”，现存200多幢明清古民居、7座古祠堂。",
        "latitude": "29.93605",
        "longitude": "117.974435",
        "icon_latitude": "29.93605",
        "icon_longitude": "117.974435",
        "icon_scale": 87,
        "icon": "marker/line/38.png",
        "wh": 1.306,
        "thumbs": [
            "marker/line/pictures/38/黟县-屏山.jpg",
            "marker/line/pictures/38/黟县-屏山1.jpg",
            "marker/line/pictures/38/黟县-屏山2.jpg"
        ]
    },
    {
        "id": 39,
        "type": 3,
        "name": "南屏（4A）",
        "address": "黟县碧阳镇南屏村",
        "tel": "0559-5164723",
        "desc": "是一座有千年历史、规模宏大的古村落，完整保留了近300座明清古建筑，被誉为“中国古祠堂建筑博物馆”。 ",
        "latitude": "29.898719",
        "longitude": "117.905067",
        "icon_latitude": "29.898719",
        "icon_longitude": "117.905067",
        "icon_scale": 87,
        "icon": "marker/line/39.png",
        "wh": 1.31,
        "thumbs": [
            "marker/line/pictures/39/黟县-南屏.jpg",
            "marker/line/pictures/39/黟县-南屏1.jpg",
            "marker/line/pictures/39/黟县-南屏2.jpg",
            "marker/line/pictures/39/黟县-南屏3.jpg"
        ]
    },
    {
        "id": 40,
        "type": 3,
        "name": "打鼓岭（4A）",
        "address": "黟县美溪乡庙林村",
        "tel": "0559-5147777",
        "desc": "此地山高谷狭，莽莽丛林间群峰叠起，一道瀑布在山崖间三番冲折，水声几经山谷回响，像无数面锣鼓在敲打，因而得名。 ",
        "latitude": "30.076412",
        "longitude": "117.821611",
        "icon_latitude": "30.076412",
        "icon_longitude": "117.821611",
        "icon_scale": 115,
        "icon": "marker/line/40.png",
        "wh": 1.365,
        "thumbs": [
            "marker/line/pictures/40/黟县-打鼓岭.jpg",
            "marker/line/pictures/40/黟县-打鼓岭1.jpg",
            "marker/line/pictures/40/黟县-打鼓岭2.jpg"
        ]
    },
    {
        "id": 41,
        "type": 3,
        "name": "黟县古城",
        "address": "黟县碧阳镇黟县古城",
        "tel": "",
        "desc": "保留着大量完整的明清时期建筑，历史街巷肌理清晰，现有3条省级历史文化街区、228处古建筑、各级文物保护单位48处。",
        "latitude": "29.924503",
        "longitude": "117.936909",
        "icon_latitude": "29.924503",
        "icon_longitude": "117.936909",
        "icon_scale": 100,
        "icon": "marker/line/41.png",
        "wh": 1.214,
        "thumbs": [
            "marker/line/pictures/41/黟县-黟县古城.jpg",
            "marker/line/pictures/41/黟县-黟县古城1.jpg"
        ]
    },
    {
        "id": 42,
        "type": 3,
        "name": "木坑竹海",
        "address": "黟县宏村镇星光村",
        "tel": "0559-5546918",
        "desc": "以竹海闻名，是黄山入黟第一寨，又称“滴翠谷”。漫山的竹林，隐逸静谧，是著名电影《卧虎藏龙》取景地。",
        "latitude": "29.997202",
        "longitude": "118.025693",
        "icon_latitude": "29.997202",
        "icon_longitude": "118.025693",
        "icon_scale": 109,
        "icon": "marker/line/42.png",
        "wh": 1.079,
        "thumbs": [
            "marker/line/pictures/42/黟县-木坑竹海.jpg",
            "marker/line/pictures/42/黟县-木坑竹海1.jpg"
        ]
    },
    {
        "id": 43,
        "type": 3,
        "name": "石林",
        "address": "黄山市黟县西递镇叶村",
        "tel": "0559-5231019",
        "desc": "景区拥有独特的喀斯特地貌，岩石形状各异，千姿百态，似猛虎恶兽，如人物雕像，鬼斧神工。",
        "latitude": "29.899879",
        "longitude": " 118.047087",
        "icon_latitude": "29.893699",
        "icon_longitude": "117.995714",
        "icon_scale": 80,
        "icon": "marker/line/43.png",
        "wh": 0.979,
        "thumbs": [
            "marker/line/pictures/43/黟县-石林.jpg",
            "marker/line/pictures/43/黟县-石林1.jpg",
            "marker/line/pictures/43/黟县-石林2.jpg"
        ]
    },
    {
        "id": 44,
        "type": 3,
        "name": "塔川",
        "address": "黄山市黟县Y102",
        "tel": "",
        "desc": "是一个独具魅力的山间村落。村落依山而建，飞檐翘角的古民居，层层叠叠，错落有致，远远望去，就好像一座宝塔矗立在山谷之中，此为“塔”之来历；一条清澈的小溪穿村潺潺流过，给小村带来无穷灵气，此为“川”之来历。每当秋季来临，古老的乌桕树婀娜多姿、姹紫嫣红，仿若走进童话里的秋天。",
        "latitude": "30.01761",
        "longitude": "118.007538",
        "icon_latitude": "30.01761",
        "icon_longitude": "118.007538",
        "icon_scale": 90,
        "icon": "marker/line/44.png",
        "wh": 1.004,
        "thumbs": [
            "marker/line/pictures/44/黟县-塔川.jpg",
            "marker/line/pictures/44/黟县-塔川1.jpg",
            "marker/line/pictures/44/黟县-塔川2.jpg",
            "marker/line/pictures/44/黟县-塔川3.jpg"
        ]
    },
    {
        "id": 46,
        "type": 3,
        "name": "祥源·祁红文化产业博览园（4A）",
        "address": "祁门县华扬工业园区祥源祁红产业文化博览园",
        "tel": "0559-2218000",
        "desc": "目前中国唯一的集祁门红茶主题博物馆、国家级非物质文化遗产体验车间、世界级现代化祁门红茶生产线为一体的综合性产业园。",
        "latitude": "29.842768",
        "longitude": "117.749542",
        "icon_latitude": "29.842768",
        "icon_longitude": "117.749542",
        "icon_scale": 76,
        "icon": "marker/line/46.png",
        "wh": 4.49,
        "thumbs": [
            "marker/line/pictures/46/祁门-祥源·祁红文化产业博览园.jpg",
            "marker/line/pictures/46/祁门-祥源·祁红文化产业博览园1.jpg",
            "marker/line/pictures/46/祁门-祥源·祁红文化产业博览园2.jpg"
        ]
    },
    {
        "id": 47,
        "type": 3,
        "name": "东街历史文化街区",
        "address": "祁门县东街历史文化街区",
        "tel": "",
        "desc": "东街成于明代，兴于清代，总建筑面积约8万平米，其中有国家级文保单位1处（洪家大屋），含8幢老宅（王家燕舍、马家、谭家、周家、胡家、万家、汪家、冯家）在内的历史建筑67处。",
        "latitude": "29.854516",
        "longitude": "117.71863",
        "icon_latitude": "29.854516",
        "icon_longitude": "117.71863",
        "icon_scale": 115,
        "icon": "marker/line/47.png",
        "wh": 1.807,
        "thumbs": [
            "marker/line/pictures/47/祁门-东街历史文化街区.jpg",
            "marker/line/pictures/47/祁门-东街历史文化街区2.jpg"
        ]
    },
    {
        "id": 48,
        "type": 3,
        "name": "黄山屯溪国际机场",
        "address": "屯溪区龙井路8号",
        "tel": "0559-2934999",
        "desc": "",
        "latitude": "29.73039",
        "longitude": "118.260716",
        "icon_latitude": "29.73039",
        "icon_longitude": "118.260716",
        "icon_scale": 120,
        "icon": "marker/line/48.png",
        "wh": 1.781,
        "thumbs": [
            "marker/line/pictures/48/黄山屯溪国际机场.png"
        ]
    },
    {
        "id": 49,
        "type": 3,
        "name": "黄山高铁北站",
        "address": "屯溪区迎客松大道北2号",
        "tel": "0559-12306",
        "desc": "",
        "latitude": "29.814866",
        "longitude": "118.273628",
        "icon_latitude": "29.75486",
        "icon_longitude": "118.273628",
        "icon_scale": 120,
        "icon": "marker/line/49.png",
        "wh": 1.415,
        "thumbs": [
            "marker/line/pictures/49/黄山北站.png"
        ]
    },
    {
        "id": 50,
        "type": 3,
        "name": "黄山高铁西站",
        "address": "黄山区甘棠镇兴村",
        "tel": "0559-12306",
        "desc": "",
        "latitude": "30.277523",
        "longitude": "118.089448",
        "icon_latitude": "30.277523",
        "icon_longitude": "118.089448",
        "icon_scale": 120,
        "icon": "marker/line/50.png",
        "wh": 1.415,
        "thumbs": [
            "marker/line/pictures/50/黄山西站.png"
        ]
    },
    {
        "id": 51,
        "type": 3,
        "name": "黟县高铁东站",
        "address": "黟县西递镇源川村",
        "tel": "0559-12306",
        "desc": "",
        "latitude": "29.884967",
        "longitude": "118.047733",
        "icon_latitude": "29.884967",
        "icon_longitude": "118.017733",
        "icon_scale": 120,
        "icon": "marker/line/51.png",
        "wh": 1.415,
        "thumbs": [
            "marker/line/pictures/51/黟县东站_.png"
        ]
    },
    {
        "id": 52,
        "type": 3,
        "name": "祁门高铁南站",
        "address": "祁门县中心城区南面",
        "tel": "0559-12306",
        "desc": "",
        "latitude": "29.832649",
        "longitude": "117.69929",
        "icon_latitude": "29.832649",
        "icon_longitude": "117.69929",
        "icon_scale": 120,
        "icon": "marker/line/52.png",
        "wh": 1.415,
        "thumbs": [
            "marker/line/pictures/52/祁门南站.png"
        ]
    },
    {
        "id": 53,
        "type": 3,
        "name": "歙县高铁北站",
        "address": "歙县富堨镇承狮村北",
        "tel": "0559-12306",
        "desc": "",
        "latitude": "29.921445",
        "longitude": "118.410987",
        "icon_latitude": "29.921445",
        "icon_longitude": "118.410987",
        "icon_scale": 120,
        "icon": "marker/line/53.png",
        "wh": 1.415,
        "thumbs": [
            "marker/line/pictures/53/歙县北站.png"
        ]
    },
    {
        "id": 54,
        "type": 3,
        "name": "歙县高铁三阳站",
        "address": "歙县三阳镇",
        "tel": "0559-12306",
        "desc": "",
        "latitude": "30.027048",
        "longitude": "118.807798",
        "icon_latitude": "30.027048",
        "icon_longitude": "118.807798",
        "icon_scale": 120,
        "icon": "marker/line/54.png",
        "wh": 1.415,
        "thumbs": [
            "marker/line/pictures/54/三阳站.png"
        ]
    }
]